<script>
  export let fields = {}

  $: isEmpty = fields?.text === '<p></p>' || !fields?.text
</script>

{#key fields?.text}
  <div
    class="jolojo-text"
    class:empty={isEmpty}
    style:background={fields?.background}
    style:color={fields?.foreground}
    style:padding={`${fields?.padding}px`}
  >
    {#if !isEmpty}
      {@html fields?.text}
    {:else}
      <h3>Text</h3>
    {/if}
  </div>
{/key}

<style lang="scss">.jolojo-text {
  width: 100%;
  min-width: 50px;
}

:global(.jolojo-text p) {
  min-height: 1rem;
}

.empty {
  outline: dashed 2px #888;
  padding: 20px 5px;
  width: 100%;
  display: grid;
  place-items: center;
  border-radius: 6px;
}
.empty h3 {
  margin: 0;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>